export const patientDeleteReasons = [
  'Accidental created encounter - (delete enc)',
  'Duplicate Encounter - (delete enc)',
  'Duplicate patient ID - (delete patient)',
  'Accidentally created patient - (delete patient)',
  'Other (specify if enc or pt gets deleted)'
];
